import { motion } from "framer-motion";

export default function KpiCard({ label, value, unit, delta, deltaDir, testid, index = 0 }) {
  const deltaColor =
    deltaDir === "up" ? "text-[#B24F35]" :
    deltaDir === "down" ? "text-[#8FA38B]" : "text-[#6E716C]";

  return (
    <motion.div
      data-testid={testid}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.08, ease: "easeOut" }}
      className="flat-card p-6 sm:p-7 flex flex-col justify-between min-h-[152px]"
    >
      <div className="overline">{label}</div>
      <div className="mt-6">
        <div className="flex items-baseline gap-2">
          <span className="font-mono-data text-4xl font-light tracking-tighter text-[#0F3524]">
            {value}
          </span>
          {unit && (
            <span className="font-mono-data text-sm text-[#6E716C]">{unit}</span>
          )}
        </div>
        {delta && (
          <div className={`mt-2 text-xs font-mono-data ${deltaColor}`}>
            {deltaDir === "up" ? "▲" : deltaDir === "down" ? "▼" : "•"} {delta}
          </div>
        )}
      </div>
    </motion.div>
  );
}
